export function logEvent(eventName: string): void {
  console.debug(`TRACKING: ${eventName}`);
}
